module.exports = __webpack_public_path__ + "img/skip-forward.54860911.svg";